<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->
    <div class="faq-jumbotron">
      <div
        class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base"
      >
        <h1 class="mb-1 text-white">Du hast Fragen?</h1>
        <p class="text-white">
          Lies hier die am häufigsten gestellten Fragen und Antworten
        </p>
        <vs-input
          placeholder="Suchen"
          v-model="faqSearchQuery"
          icon-pack="feather"
          icon="icon-search"
          size="large"
          class="w-full mt-6"
          icon-no-border
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/4 rounded-lg">
        <vx-card>
          <h4>Kategorien</h4>
          <ul class="faq-topics mt-4">
            <li
              v-for="category in categories"
              :key="category.id"
              class="p-2 font-medium flex items-center"
              @click="faqFilter = category.id"
            >
              <div
                class="h-3 w-3 rounded-full mr-2"
                :class="'bg-' + category.color"
              ></div>
              <span class="cursor-pointer">{{ category.name }}</span>
            </li>
          </ul>



        </vx-card>
      </div>

      <!-- FAQ COL -->
      <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
        <vs-collapse accordion type="margin" class="p-0">
          <vs-collapse-item
            v-for="(que, index) in filteredFaq"
            class="faq-bg rounded-lg"
            :class="{ 'mt-0': !index }"
            :key="que.id"
          >
            <div slot="header">
              <h5>{{ que.question }}</h5>
            </div>
            <p>{{ que.ans }}</p>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqSearchQuery: "",
      faqFilter: 1,
      categories: [
        {
          id: 1,
          name: "Alle",
          color: "grey",
        },
        {
          id: 2,
          name: "Bestellen",
          color: "primary",
        },
        {
          id: 3,
          name: "Bezahlen",
          color: "success",
        },
        {
          id: 4,
          name: "Lieferung",
          color: "warning",
        },
        {
          id: 5,
          name: "Qualität",
          color: "danger",
        },
      ],
      faqs: [
        {
          id: 1,
          categoryId: 2,
          question: "Wie tätige ich eine Bestellung?",
          ans:
            `Bei Palace of Kebap kannst Du in 3 einfachen Schritten online Essen bestellen: (1) Speisen auswählen (2) Adresse eingeben (3) Online oder Bar bezahlen. Tipp: Wenn Du Dich bei palaceofkebap.de registrierst, musst Du Deine Daten nicht jedes Mal komplett neu eintragen!`,
        },
        {
          id: 2,
          categoryId: 2,
          question: "Wie ändere ich eine Bestellung?",
          ans:
            "Vor der Online-Bezahlung kannst du jederzeit zur Auswahl der Speisen zurückkehren und diese ändern.",
        },
        {
          id: 3,
          categoryId: 3,
          question: "Wie kann ich meine Bestellung bezahlen?",
          ans:
            "Du kannst ganz einfach per PayPal, Kreditkarte oder Bar bezahlen.",
        },
        {
          id: 4,
          categoryId: 3,
          question: "Wie hoch sind die Transaktionskosten?",
          ans:
            "Die Transaktionskosten für PayPal bzw. Stripe für Kreditkarten sind im Preis mitinbegriffen.",
        },
        {
          id: 5,
          categoryId: 4,
          question:
            "Was passiert nachdem ich eine Bestellung getätigt habe?",
          ans:
            "Die Bestellung geht unmittelbar bei uns ein und wird bearbeitet. Anschließend ist ein Fahrer auf dem Weg zu dir.",
        },
        {
          id: 6,
          categoryId: 4,
          question:
            "Wie lange dauert die Lieferung meiner Bestellung?",
          ans:
            "In der Regel liefern wir in unter einer Stunde zu dir nach Hause. Sollte es einmal länger dauern, geben wir dir frühzeitig Bescheid.",
        },
        {
          id: 7,
          categoryId: 4,
          question: "Wie hoch sind die Lieferkosten meiner Bestellung?",
          ans:
            "Ab einem Mindestbestellwert von 15€ ist die Lieferung kostenlos.",
        },
        {
          id: 8,
          categoryId: 5,
          question:
            "Welche Qualität hat unser Döner?",
          ans:
            "Die Berliner Verkehrsauffassung für das Fleischerzeugnis Döner Kebap ist das Deutsche Reinheitsgebot für den Döner. Die Verkehrsauffassung legt die Zusammensetzung des Döners fest. Neben Fleisch darf der Döner verschiedene Gewürze, Zwiebeln, Öl, Milch und Joghurt enthalten. Verboten sind Wurst- und Brotreste sowie Binde- und Konservierungsmittel. Mehr als 60% Hackfleischanteil sind nicht erlaubt.",
        },
        {
          id: 9,
          categoryId: 5,
          question:
            "Ist unser Döner gesund?",
          ans:
            "Der Döner Kebab schmeckt und sieht nicht nur gut aus! Auf die inneren Werte können sich sehen lassen – und das ist in einer Beziehung schließlich das Wichtigste!",
        },
        {
          id: 10,
          categoryId: 5,
          question:
            "Warum sind eure Preise online etwas höher als im Lokal?",
          ans:
            "Bei Lieferungen haben wir leider höhere Kosten und daher sind auch die Preise etwas höher. Wir haben bei jeder Bestellung Transaktionskosten für die Zahlungsabwicklung mit Paypal und der Kreditkarte. Daneben haben wir Sprit-, Führparks- und höhere Personalkosten pro Bestellung.",
        },
        {
          id: 11,
          categoryId: 5,
          question:
            "Warum ist der Döner Kebap bei Palace of Kebap im Vergleich zu herkömmlichen Anbietern teurer?",
          ans:
            `Unser Döner Kebap schmeckt so gut, weil wir einen so hohen Wert auf die Qualität legen. Bei uns verwenden wir nur das qualitativ beste Fleisch. Wir dürfen uns deshalb auch „Döner Kebap“ nennen, weil wir Fleischscheiben aufstecken!
              Viele herkömmliche Anbieter bieten dagegen häufig „Hackfleischspieße“ mit dem Zusatz „gewürzt nach Döner Kebap Art“ an. Hierbei handelt es sich um fein zerkleinertes Fleisch, welches mit Bindemitteln bearbeitet wird. Die Verwendung von Fleischscheiben finden hier nicht oder nur in einem sehr geringen Maße statt.
`,
        },
        {
          id: 12,
          categoryId: 4,
          question:
            "Warum ist der Lieferdienst gerade nicht erreichbar?",
          ans:
            `Dies kann zwei Gründe haben: (1) Wir möchten natürlich, dass du unser köstliches Essen immer schnell und warm genießen kannst. Deshalb kann es vorkommen, dass bei einem hohen Zulauf an Bestellungen unser Lieferdienst kurzzeitig nicht erreichbar ist. Probiere es dann einfach in ein paar Minuten nochmal aus! (2) Bitte beachte ebenso, dass wir nur zu unseren Öffnungszeiten liefern.`,
        },
        {
          id: 13,
          categoryId: 4,
          question:
            "Wohin liefert Palace of Kebap?",
          ans:
            `Wir beliefern aktuell viele verschiedene Stadtteile in Düsseldorf. Wenn deine Adresse eine der folgenden Postleitzahlen aufweist, beliefern wir dich gerne mit unseren leckeren Speisen: 40210, 40211, 40212, 40213, 40215, 40217, 40219, 40227, 40233, 40235, 40237, 40239, 40468, 40470, 40472, 40474, 40476, 40477, 40479, 40545, 40547.`,
        },
         {
          id: 14,
          categoryId: 1,
          question:
            "Weitere Fragen oder Anmerkungen?",
          ans:
            `Solltest Du weitere Fragen, Anmerkungen oder konstruktive Kritik haben, wende Dich bitte gerne jederzeit an uns! Du kannst uns unter folgender E-Mail info@palaceofkebap.de schreiben. Wir freuen uns auf deine Nachricht.`,
        },
       
      ],
    };
  },
  computed: {
    filteredFaq() {
      return this.faqs.filter((faq) => {
        if (this.faqFilter === 1)
          return (
            faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
            faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase())
          );
        else if (this.faqFilter === 2)
          return (
            faq.categoryId === 2 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter === 3)
          return (
            faq.categoryId === 3 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter === 4)
          return (
            faq.categoryId === 4 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter === 5)
          return (
            faq.categoryId === 5 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
      });
    },
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss">
#faq-page {
  .faq-jumbotron-content {
    background-image: url("../assets/images/kebap-background.jpg");
    background-size: cover;
  }

  .faq-bg {
    background-color: #fff;
  }
}
</style>